// --------------------------------------------------
// FILTER: trend
// Display the trend of two numbers
// --------------------------------------------------

import { isNil } from 'lodash-es';
import { percentage } from './percentage';

export function trend(value: number, compare?: number, negate?: boolean) {
	let percent = value;
	if (!isNil(compare)) {
		percent = value / compare - 1;
	}

	let class_name = 'trending-neutral';
	if (percent > 0.02) {
		class_name = 'trending-up';
	} else if (percent < -0.02) {
		class_name = 'trending-down';
	}

	if (negate) {
		if (percent > 0.02) {
			class_name = 'trending-down';
		} else if (percent < -0.02) {
			class_name = 'trending-up';
		}
	}

	let percent_value = percentage(percent, 2);
	if (percent > 0.02) percent_value = `+${percent_value}`;

	return `<span class="${class_name}">${percent_value}</span>`;
}
